import { useState, useEffect, useCallback } from "react";
import { getPointsSettings } from "../services/Payment_service";

interface PointsSettings {
  multiplier: number;
  point_value: number;
}

export const usePointsCalculator = () => {
  const [pointsSettings, setPointsSettings] = useState<PointsSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPointsSettings = async () => {
      try {
        const settings = await getPointsSettings();
        setPointsSettings(settings);
      } catch (err: any) {
        setError(err.message || "Erreur lors de la récupération des paramètres");
        console.error("Erreur usePointsCalculator:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPointsSettings();
  }, []);

  const calculatePoints = useCallback(
    (montantTTC: number): number => {
      if (!pointsSettings || montantTTC <= 0) return 0;

      const amountInCents = Math.round(montantTTC * 100);
      return Math.floor((amountInCents / 100) * pointsSettings.multiplier);
    },
    [pointsSettings]
  );

  return {
    calculatePoints,
    loading,
    error,
    pointsSettings
  };
};
